export default __webpack_public_path__ + "static/media/0xf84bd51eab957c2e7b7d646a3427c5a50848281d.3a5ef51d.png";